import React from 'react';

import { Typography } from 'antd';

import { FormattedMessage } from 'react-intl';

import messages from 'i18n/messages/gridView';

const DisplayTotalItem = ({ totalPagination }) => {
  return (
    <>
      <Typography.Text strong style={{ marginLeft: 6 }}>
        {typeof totalPagination === 'number'
          ? totalPagination.toLocaleString()
          : ''}
      </Typography.Text>
      &nbsp;
      <FormattedMessage {...messages.totalItems} />
    </>
  );
};

export default DisplayTotalItem;
